import { render } from "./QuestionBankEdit.vue?vue&type=template&id=3031b680&scoped=true"
import script from "./QuestionBankEdit.vue?vue&type=script&lang=js"
export * from "./QuestionBankEdit.vue?vue&type=script&lang=js"

import "./QuestionBankEdit.vue?vue&type=style&index=0&id=3031b680&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3031b680"]])

export default __exports__